module.exports = __webpack_public_path__ + "img/TKL_menu2.4ef4a74a.png";